export const selectJobPromotionState = (state) => state.jobPromotion;
